module.exports = __webpack_public_path__ + "static/backdrop-138b9cf627209ce82bce85ccdab979d0.jpg";